export default __webpack_public_path__ + "static/1557941274388-2a8e7f247242290c4cd62c7efb6628f8.jpeg";